export default __webpack_public_path__ + "static/media/Database and other tools.4cf9ba2c.svg";